import { render, staticRenderFns } from "./skScore.vue?vue&type=template&id=13b0fb2d&scoped=true&"
import script from "./skScore.vue?vue&type=script&lang=js&"
export * from "./skScore.vue?vue&type=script&lang=js&"
import style0 from "./skScore.vue?vue&type=style&index=0&id=13b0fb2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0fb2d",
  null
  
)

export default component.exports